
<template>
  <div class="smy__card-full-box">
    <Card
      :bordered="false"
      class="smy__card-full"
    >
    <p slot="title">
      意见反馈
    </p>
    <div class="search">
      <!-- 详细筛选条件 -->
      <div>
        <div
          class="search-detail"
          :class="{'search-detail-close': !searchVisible}"
          :style="{overflow: !searchVisible ? 'hidden' : ''}"
        >
          <div class="search-detail-item">
            <Input
              class="search-input"
              placeholder="请输入企业名称"
              v-model="searchForm.ep_name"
            ></Input>
          </div>
          <div class="search-detail-item">
            <Input
              class="search-input"
              placeholder="请输入corpID"
              v-model="searchForm.corpid"
            ></Input>
          </div>
          <div class="search-detail-item">
            <Button
              type="primary"
              class="search-button"
              @click="pageIndex=0,loadList()"
            >查找</Button>
            <Button
              class="search-button"
              @click="resetSearchForm"
            >重置</Button>
          </div>
        </div>
      </div>
    </div>
    <div class='button-group'>
        <Button-group>
            <i-button
              :type="searchForm.process_state === 0  ? 'primary' : 'ghost'"
              @click="undealSearchForm"
              >未处理</i-button>
            <i-button 
              :type="searchForm.process_state === 1  ? 'primary' : 'ghost'"
              @click="dealSearchForm"
              >已处理</i-button>
        </Button-group>
    </div>
    <!-- 工单列表 -->
    <div class="table">
      <Table
        stripe
        ref="table"
        :loading="listLoading"
        :columns="columns"
        :data="list"
      ></Table>
    </div>
    <!-- 分页控件 -->
    <Page
      show-total
      show-sizer
      class="page"
      placement="top"
      :current="pageIndex + 1"
      :total="count"
      :page-size-opts="pageSizeOpts"
      @on-change="pageIndexChange"
      @on-page-size-change="pageSizeChange"
    ></Page>
    <!-- 查看详情弹框 -->
    <Modal
      v-model="editListModal"
      :mask-closable="false"
      :title="detailTitle"
      :loading="modalLoading"
      @on-ok="confirm()"
    >
      <div>
        <p>
          <span class='modelName'>企业ID</span>
          <span class='space'></span>
          {{modelData.ep_id}}
        </p>
        <p>
          <span class='modelName'>企业名称</span>
          <span class='space'></span>
          {{modelData.ep_name}}
        </p>
        <p>
          <span class='modelName'>corpID</span>
          <span class='space'></span>
          {{modelData.corpid}}
        </p>
        <p>
          <span class='modelName'>用户名</span>
          <span class='space'></span>
          {{modelData.user_name}}
        </p>
        <p>
          <span class='modelName'>邮箱地址</span>
          <span class='space'></span>
          {{modelData.contact_way}}
        </p>
        <p>
          <span class='modelName'>反馈时间</span>
          <span class='space'></span>
          {{modelData.create_time}}
        </p>
        <p>
          <span class='modelName'>反馈内容</span>
          <span class='space'></span>
          {{modelData.content}}
        </p>
      </div>
    </Modal>
  </Card>
 </div>
</template>

<script>
import { mapState } from 'vuex'

import DateRangePicker from '@/components/DateRangePicker'

export default {
  components: {
    DateRangePicker
  },
  data () {
    return {
      detailTitle: '查看详情', // 对话框标题
      modalLoading: true,
      editListModal: false, // 导出对话框
      chouseState: '',
      currPackageId: 1,
      buyPeople: '',
      busType: '',
      corpid: '',
      type: 1,
      searchVisible: true, // 是否显示详细筛选条件
      pageSize: 10,
      pageIndex: 0,
      listLoading: false, // 表格加载状态
      count: 0,
      list: [],
      searchForm: {
        process_state: 0, // 处理状态
        corpid: '' // 企业corpid
      },
      modelData: {
        id: '',
        ep_name: '',
        corpid: '',
        user_name: '',
        contact_way: '',
        create_time: '',
        content: ''
      }
    }
  },
  computed: {
    ...mapState('table', [
      'columnsCheckedAll',
      'pageSizeOpts'
    ]),
    // 表格列 根据选中的列动态生成
    columns () {
      const allColumns = [
        {
          title: '操作',
          width: 200,
          align: 'center',
          fixed: 'right',
          render: (h, { row }) => {
            let check = h('div', [
              h('Button', {
                props: {
                  type: 'ghost',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.modelData.id = row.id
                    this.modelData.ep_name = row.ep_name
                    this.modelData.corpid = row.corpid
                    this.modelData.user_name = row.user_name
                    this.modelData.contact_way = row.contact_way
                    this.modelData.create_time = row.create_time
                    this.modelData.content = row.content
                    this.editListModal = true
                  }
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['查看详情']),
              h('Button', {
                props: {
                  type: 'ghost',
                  size: 'small'
                },
                on: {
                  click: () => {
                    let url = '/suggestion/unprocess'
                    let data = {
                      id: row.id
                    }
                    this.$http.post(url, data).then(res => {
                      if (res.success) {
                        this.loadList()
                      } else {
                        this.$Message.error(res.message)
                      }
                    })
                  }
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['置为未处理'])
            ])
            let check2 = h('div', [
              h('Button', {
                props: {
                  type: 'ghost',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.modelData.id = row.id
                    this.modelData.ep_name = row.ep_name
                    this.modelData.corpid = row.corpid
                    this.modelData.user_name = row.user_name
                    this.modelData.contact_way = row.contact_way
                    this.modelData.create_time = row.create_time
                    this.modelData.content = row.content
                    this.editListModal = true
                  }
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['查看详情']),
              h('Button', {
                props: {
                  type: 'ghost',
                  size: 'small'
                },
                on: {
                  click: () => {
                    let url = '/suggestion/processed'
                    let data = {
                      id: row.id
                    }
                    this.$http.post(url, data).then(res => {
                      if (res.success) {
                        this.loadList()
                      } else {
                        this.$Message.error(res.message)
                      }
                    })
                  }
                },
                style: {
                  marginLeft: '10px'
                }
              }, ['置为已处理'])
            ])
            if (row.process_state === 1) {
              return h('div', [check])
            } else {
              return h('div', [check2])
            }
          }
        },
        {
          title: '企业ID',
          key: 'ep_id',
          width: 140
        },
        {
          title: '企业名称',
          key: 'ep_name',
          width: 140
        },
        {
          title: 'corpID',
          key: 'corpid',
          width: 180,
          ellipsis: true
        },
        {
          title: '用户名',
          key: 'user_name',
          width: 140
        },
        {
          title: '邮箱地址',
          key: 'contact_way',
          width: 180,
          ellipsis: true
        },
        {
          title: '反馈时间',
          key: 'create_time',
          width: 180
        },
        {
          title: '反馈内容',
          key: 'content',
          width: 180
        },
        {
          title: ' ',
          key: ' '
        }
      ]
      return allColumns
    }
  },
  watch: {
    chouseState (val) {
    }
  },
  methods: {
    // 加载列表数据
    loadList () {
      this.listLoading = true
      this.$http.all([
        this.$http.get('/suggestion/list', {
          params: {
            pageIndex: this.pageIndex,
            pageSize: this.pageSize,
            ...this.searchForm
          }
        }),

        this.$http.get('/suggestion/count', {
          params: this.searchForm
        })
      ]).then(this.$http.spread((res1, res2) => {
        if (res1.success && res2.success) {
          this.list = res1.data
          this.count = res2.data
          this.listLoading = false
        }
      }))
    },
    // 分页 每页大小 改变回调
    pageSizeChange (pageSize) {
      this.pageSize = pageSize
      this.loadList()
    },
    // 分页 页码 改变回调
    pageIndexChange (pageIndex) {
      this.pageIndex = pageIndex - 1
      this.loadList()
    },
    // 重置搜索框
    resetSearchForm () {
      this.chouseState = ''
      this.searchForm = {
        process_state: 0, // 处理状态
        corpid: '' // 企业corpid
      }
      this.loadList()
    },
    // 已处理
    dealSearchForm () {
      this.searchForm.process_state = 1
      this.loadList()
    },
    // 未处理
    undealSearchForm () {
      this.searchForm.process_state = 0
      this.loadList()
    },
    // 弹框确定按钮
    confirm () {
      this.editListModal = false
    }
  },
  created () {
    this.$http.get('/dropdown/industry').then(res => {
      this.busType = res.data
    })
    this.$http.get('/dropdown/chargePackage').then(res => {
      this.buyPeople = res.data
    })
    this.loadList()
  }
}
</script>

<style lang="less" scoped>
.search {
  // margin-bottom: 16px;
  .search-detail {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    height: 45px;
    transition: .5s;

    .search-detail-item {
      width: 24.25%;

      .search-input {
        width: 100%;
        margin-bottom: 10px;
      }

      .search-button {
        margin-right: 6px;
        margin-bottom: 10px;
      }
    }

    .search-detail-item:nth-child(2n+1),
    .search-detail-item:nth-child(4n+2) {
      margin-right: 1%;
    }
  }

  .search-detail-close {
    height: 0;
    opacity: 0;
  }
}

.page {
  margin-top: 20px;
  margin-bottom: 10px;
}

.button-group {
    margin-bottom: 25px;
}

p {
  line-height: 25px;
  font-size: 14px;
}

p span {
  display: inline-block;
  font-size: 14px;
}

.modelName {
  min-width: 56px;
}

.space {
  width: 10px;
}
</style>



// WEBPACK FOOTER //
// src/pages/feedback/feedbacks/index.vue